import { render, staticRenderFns } from "./cart-subitem.vue?vue&type=template&id=e878cfec&scoped=true"
import script from "./cart-subitem.vue?vue&type=script&lang=ts"
export * from "./cart-subitem.vue?vue&type=script&lang=ts"
import style0 from "./cart-subitem.vue?vue&type=style&index=0&id=e878cfec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e878cfec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e878cfec')) {
      api.createRecord('e878cfec', component.options)
    } else {
      api.reload('e878cfec', component.options)
    }
    module.hot.accept("./cart-subitem.vue?vue&type=template&id=e878cfec&scoped=true", function () {
      api.rerender('e878cfec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/cart/cart-subitem.vue"
export default component.exports